import { render, staticRenderFns } from "./trainOutStudent.vue?vue&type=template&id=0eec754e&scoped=true"
import script from "./trainOutStudent.vue?vue&type=script&lang=js"
export * from "./trainOutStudent.vue?vue&type=script&lang=js"
import style0 from "./trainOutStudent.vue?vue&type=style&index=0&id=0eec754e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eec754e",
  null
  
)

export default component.exports